import { Card } from '@blueprintjs/core';
import OrganizationSelect from 'Components/Generic/BOSFilterSelect/OrganizationSelect';
import { SITE_PAGES } from 'Config';
import {
  getOrgNameFromId,
  getUserManagingOrgIds,
  getUserOrgIds,
} from 'Data/context/Organizations';
import { user_roles } from 'Data/Enum';
import { usePersistentFiltering } from 'Lib/hooks/usePersistentFiltering';
import AccountLanding from 'Pages/Accounts/AccountLanding';
import OrganizationDetails from 'Pages/Admin/Organizations/OrganizationDetails';
import { canUserViewAllCores, isUserAuthorized } from 'Util';

const BudgetLandingView = () => {
  let breadcrumb = [SITE_PAGES.BUDGETS];

  const [persistentFilter, updatePersistentFilterField] =
    usePersistentFiltering(`BUD_LANDING`);

  let excludedOrgIds = canUserViewAllCores()
    ? []
    : getUserOrgIds().filter((id) => !getUserManagingOrgIds().includes(id));

  let coreSelector = (canUserViewAllCores() ||
    getUserManagingOrgIds().length > 1) && (
    <OrganizationSelect
      key={persistentFilter?.parent_organization_id}
      defaultSelectedId={persistentFilter?.parent_organization_id}
      excludedIds={excludedOrgIds}
      onSelectOrganization={(org) =>
        updatePersistentFilterField('parent_organization_id', org?.id)
      }
      floatSelected={false}
      useLargeLabel
    />
  );

  let userManagingCoreId =
    !canUserViewAllCores() &&
    getUserManagingOrgIds().length === 1 &&
    getUserManagingOrgIds()[0];

  let pageContent = (
    <>
      <Card>
        {coreSelector || (
          <span
            style={{
              fontWeight: 600,
              fontSize: 22,
            }}>
            {getOrgNameFromId(userManagingCoreId)}
          </span>
        )}
      </Card>
      {(userManagingCoreId || persistentFilter?.parent_organization_id) && (
        <>
          <div style={{ height: 12 }} />
          <OrganizationDetails
            budgetView
            editable={isUserAuthorized({
              roles: [user_roles.BUDGETER, user_roles.ADMINISTRATOR],
            })}
            orgId={
              userManagingCoreId || persistentFilter?.parent_organization_id
            }
          />
        </>
      )}
    </>
  );

  return (
    <AccountLanding title='Budgets' breadcrumbs={breadcrumb}>
      {pageContent}
    </AccountLanding>
  );
};

export default BudgetLandingView;
